import React from 'react';

import { css, cx } from '@emotion/css';
import { useTranslation } from 'react-i18next';

import { useStyles } from '@/hooks/useStyles.ts';
import { ControlledDateField } from '@/uiKit/molecules/ControlledDateField.tsx';

export type BirthDateFieldProps = {
  className?: string;
};

export const BirthDateField: React.FC<BirthDateFieldProps> = ({
  className,
}) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();

  return (
    <div className={cx(styles.container, className)}>
      <ControlledDateField
        id="prescription-info-birth-date-input"
        label={t('profile.birthDate')}
        name="birthDate"
        required
      />
    </div>
  );
};

const makeStyles = () => ({
  container: css({}),
});
